import tools from '../tools/tools.js';
import * as THREE from 'three';
import Lenis from '@studio-freight/lenis'
import Splitting from "splitting"


const selectorAll = '.airtheme-animation'
const selectorSplitting = '.airtheme-animation-auto, .airtheme-animation-a, .airtheme-animation-b, .airtheme-animation-c, .airtheme-animation-d, .airtheme-animation-vis-auto, .airtheme-animation-vis-a, .airtheme-animation-vis-b, .airtheme-animation-vis-c, .airtheme-animation-vis-d'
const charAnimations = ['a', 'b', 'c', 'd', 'auto']
const handlersAuto = ['a','d','b','c']
const parallaxAnimations = ['parallax']
const handlersVisibleAuto = ['vis-a','vis-d','vis-b','vis-c']


const colMain = new THREE.Color('#121212')
const colEff = new THREE.Color('#ff0011')
const colMix = new THREE.Color('#000000')
const scrolls = new Set()
function doScroll(){
	scrolls.forEach((s)=>s())
}

function animations(script, isSmooth){
	const handlersChar = {
		a: {
			minDist: 0.5,
			tick: ({ch, p})=>{
				ch.style.scale = p
				const pr = 1 - p
				const rot = -90 * pr
				ch.style.transform = 'rotateX('+rot+'deg)'
			}
		},
		b: {
			minDist: 0.5,
			tick: ({ch, p})=>{
				ch.style.scale = p
				const pr = 1 - p
				const rot = -90 * pr
				ch.style.transform = 'rotateX('+rot+'deg) rotateY('+rot+'deg)'
			}
		},
		c: {
			minDist: 1,
			init: ({ch, chi, ampFactor})=>{
				return {off: ampFactor * (chi % 2 ? 1 : -1)}
			},
			tick: ({ch, p, chi, init})=>{
				ch.style.scale = p
				const pr = 1 - p
				const off = pr*init.off
				ch.style.transform = 'translate3d(0px, '+off+'px, 0px)'
			}
		},
		d: {
			minDist: 1,
			init: ({ch, chi, ampFactor})=>{
				return {off: ampFactor * (chi % 2 ? 1 : -1)}
			},
			tick: ({ch, p, chi, init})=>{
				ch.style.scale = p
				const pr = 1 - p
				const rot = -90 * pr
				const off = pr*init.off
				ch.style.transform = 'rotateX('+rot+'deg) translate3d(0px, '+off+'px, 0px)'
			}
		}
	}
	const handlersParallax = {
		parallax: {
			minDist: 1,
			init: ({el, ampFactor})=>{
				return {off: ampFactor}
			},
			tick: ({el, p, init})=>{
				const pr = 1 - p
				const off = -1*pr*init.off
				el.style.transform = 'translate3d(0px, '+off+'px, 0px)'
			}
		}
	}
	Splitting({
		target: selectorSplitting,
	})
	let visInd = 0
	let chInd = 0
	document.querySelectorAll(selectorAll).forEach(function(el, eli){
		let init
		let scroll
		if(charAnimations.indexOf(el.dataset.airthemeAnimation) > -1){
			const padds = {start: 0.2, end: 1}
			let oldProgr = false
			let progress
			let chProgress
			const chars = el.querySelectorAll('.char');
			let hnd;
			const isAuto = el.dataset.airthemeAnimation === 'auto'
			const hndId = isAuto ? handlersAuto[chInd % handlersAuto.length] : el.dataset.airthemeAnimation
			hnd = handlersChar[hndId]
			const chProg = (progr, i, minDist)=>{
				if(chars.length>1){
					const posi = i / (chars.length-1)
					return progr / (minDist + (1 - minDist)*posi)
				}else{
					return progr
				}
			}
			init = (pos, posB)=>{
				if(posB > window.innerHeight){
					let scrollVisibleStart = pos - window.innerHeight + Math.min(100, el.offsetHeight * padds.start)
					let scrollVisibleEnd = pos - Math.min(100, el.offsetHeight * padds.end)
					progress = ()=>{
						return (window.scrollY - scrollVisibleStart)/(scrollVisibleEnd - scrollVisibleStart)
					}
					chProgress = chProg
				}else{
					const end = pos + 0.7*el.offsetHeight
					progress = ()=>{
						return (end - window.scrollY)/end
					}
					chProgress = (progr, i, minDist)=>{
						return chProg(progr, chars.length-1-i, minDist)
					}
				}
			}
			let inits = false
			if(hnd.init){
				const ampFactor = 0.6 * parseInt(window.getComputedStyle(el ,null).getPropertyValue('font-size'))
				inits = new Array(chars.length)
				chars.forEach((ch, chi)=>{
					inits[chi] = hnd.init({ch, chi, ampFactor})
				})
			}
			scroll = ()=>{
				let progr = progress()
				if(progr !== oldProgr){
					chars.forEach((ch, chi)=>{
						let p = chProgress(progr, chi, hnd.minDist)
						if(p < 0){
							p = 0
						}else if(p > 1){
							p = 1
						}
						hnd.tick({ch, p, init: inits ? inits[chi] : null, chi})
					})
					oldProgr = progr
				}
			}
			chInd++
		}else if(parallaxAnimations.indexOf(el.dataset.airthemeAnimation) > -1){
			const padds = {start: 0.2, end: 1}
			let oldProgr = false
			let progress
			let hnd;
			const hndId = el.dataset.airthemeAnimation
			hnd = handlersParallax[hndId]
			init = (pos, posB)=>{
				if(posB > window.innerHeight){
					let scrollVisibleStart = pos - window.innerHeight
					let scrollVisibleEnd = posB - 220
					progress = ()=>{
						return (window.scrollY - scrollVisibleStart)/(scrollVisibleEnd - scrollVisibleStart)
					}
				}else{
					const end = pos + 0.7*el.offsetHeight
					progress = ()=>{
						return (end - window.scrollY)/end
					}
				}
			}
			let initObj = false
			if(hnd.init){
				const ampFactor = 80
				initObj = hnd.init({el, ampFactor})
			}
			scroll = ()=>{
				let p = progress()
				if(p !== oldProgr){
					if(p < 0){
						p = 0
					}else if(p > 1){
						//p = 1
					}
					hnd.tick({el, p, init: initObj ? initObj : null})
					oldProgr = p
				}
			}
		}else{
			let oldState = -1
			let hnd;
			if(el.dataset.airthemeAnimation === 'vis-auto'){
				const animId = handlersVisibleAuto[visInd % handlersVisibleAuto.length]
				el.classList.add('airtheme-animation-'+animId)
			}
			let scrollVisibleMin
			let scrollVisibleMax
			el.classList.add('airtheme-animation-by-visible')
			init = (pos, posB)=>{
				scrollVisibleMin = pos - window.innerHeight
				scrollVisibleMax = posB
			}
			scroll = ()=>{
				const state = window.scrollY < scrollVisibleMin || window.scrollY > scrollVisibleMax ? 1 : 2
				if(state !== oldState){
					if(state === 1){
						el.classList.remove('airtheme-animation-visible')
					}else{

						el.classList.add('airtheme-animation-visible')
					}
					oldState = state
				}
			}
			visInd++
		}
		let oldW = -1
		let oldH = -1
		const resize = ()=>{
			const w = document.body.scrollWidth
			const h = document.body.scrollHeight
			if(w!==oldW || h!==oldH){
				let pos = 0;
				let ele = el
				while( ele && !isNaN( ele.offsetLeft ) && !isNaN( ele.offsetTop ) ) {
					pos += ele.offsetTop - ele.scrollTop;
					ele = ele.offsetParent;
				}
				const posB = pos + el.offsetHeight
				init(pos, posB)
				oldW = w
				oldH = h
			}
			scroll()
		}
		resize()
		const resizeObserverC = new ResizeObserver(resize);
		resizeObserverC.observe(document.body);
		scrolls.add(scroll)
	})
	if(isSmooth){
		const lenis = new Lenis({
			//Good result via 'duration: 0.6' (1.2 by default) or 'lerp: 0.2'
			// But duration should be setted for CSS workaround for iframe: .lenis-scrolling iframe{pointer-events: none;}
			duration: 0.6,
			smoothWheel: true
		})
		lenis.on('scroll', doScroll)
		function raf(time) {
			lenis.raf(time)
			requestAnimationFrame(raf)
		}
		requestAnimationFrame(raf)
		script.lenis = lenis
		document.querySelectorAll('#airtheme-primary a[href^="#"], #airtheme-footer a[href^="#"]').forEach(function(el){
			if(el.hash.length > 1){
				el.onclick = (e)=>{
					e.preventDefault()
					lenis.scrollTo(el.hash)
				}
			}
		})
	}else{
		document.addEventListener('scroll', doScroll, tools.passiveListener)
	}
}
export default animations;
